/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */

window.onload = function() {
  const loadingElement = document.getElementById("wish-loading");
  const productContainer = document.getElementById("wishlist-products-container");
  const compareMenu = document.querySelector(".compare-floating-menu");
  const gestText = document.querySelector(".wishlist-gest-text");

  // 初期表示
  loadingElement.style.display = 'flex';


  // 商品が表示されたらローディングを消す
  const checkLoaded = setInterval(() => {
    if (productContainer && productContainer.children.length > 0) {

      loadingElement.style.display = 'none';
      loadingElement.style.height = '0';
      compareMenu.style.display = 'flex'; 
      gestText.style.display = 'block';
      clearInterval(checkLoaded);
    }
  }, 500); // 0.5秒ごとにチェック
};



function getVariantInfo(variants) {
    try {
        let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
            variantinfo;
        if (variantKeys.length > 0) {
            variantinfo = variantKeys[0];
            if (variantinfo == "Default Title") {
                variantinfo = "";
            }
        } else {
            variantinfo = "";
        }
        return variantinfo;

    } catch (err) {
        return variants;
    }
}

function swymRenderWishlist(swat) {
    swat.fetch(async function(products) {
        var wishlistContentsContainer = document.getElementById("wishlist-items-container");
        var formattedWishlistedProducts = products.map(function(p) {
            p = SwymUtils.formatProductPrice(p); 
            p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
            p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
            return p;
        });

    const addInfoProducts = async (products) => {
      const newProducts = [];
      const formatter = new Intl.NumberFormat('ja-JP'); 
      for (const product of products) {
                try {
                    const handlizedProduct = shopifyHandleize(product.dt);
                    const res = await fetch(window.Shopify.routes.root + `products/${handlizedProduct}.js`);

                    if (res.status == "200") {
                        const data = await res.json();
                        newProducts.push({...product, available: data.available, formattedPrice: formatter.format(Number(data.price / 100)) });
                    }
                } catch (error) {
                    console.error("Error", error);
                }
      }
      return newProducts;
    };
        const fetchedProducts = await addInfoProducts(formattedWishlistedProducts);
        var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
            products: fetchedProducts
        });
        if(wishlistContentsContainer){
            wishlistContentsContainer.innerHTML = Boolean(fetchedProducts.length) ? productCardsMarkup : noItemText;
            attachClickListeners();
            afterch();

        } else{
          console.log("Container not found, Wishlist Page element not found");
        }
    });
}


function shopifyHandleize(str) {
    str = str.toLowerCase();
    var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
    for (var i = 0; i < toReplace.length; ++i) {
        str = str.replace(toReplace[i], "");
    }
    str = str.replace(/\W+/g, "-");
    if (str.charAt(str.length - 1) == "-") {
        str = str.replace(/-+\z/, "");
    }
    if (str.charAt(0) == "-") {
        str = str.replace(/\A-+/, "");
    }
    return str;
}

function attachClickListeners() {
    var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
    var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
    for (var i = 0; i < addToCartButtons.length; i++) {
        addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
    }
    for (var k = 0; k < removeBtns.length; k++) {
        removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
    }
    console.log("Events attached!");
}

// 他の関連する関数を上記と同様に保持
